export class invoice {
    id: number;
    invoice_id: string;
    invoice_to: string;
    email: string;
    phone: string;
    location: {
        address: string;
        city: string;
        state: string;
        country: string;
        zip: string;
        final_location: string
    };
    payment: {
        no_card: boolean;
        paid_by: string;
        card_no: string;
        card: string;
    };
    transactions: {
        sr_no: number;
        description: string;
        date: string;
        amount: string;
    }[];
    total: string;
    consultation_specialties: string;
}

export interface PatientAccountInvoice {
    first_name: string;
    middle_name: string;
    last_name: string;
    date_of_birth: Date;
    address_line_1: string;
    address_line_2: string;
    city: string;
    state_name: string;
    state_id: number;
    zip_code: string;
    primary_contact_number: string;
    secondary_contact_number: string;
    avatar_key: string;
    identification_type: string;
    identification_url: string;
    identification_key: string;
    transactions: {
        transaction_no: string;
        amount: string;
        currency_type: string;
        p_invoice: {
            invoice_id: string;
            invoice_key: string;
            invoice_url: string;
            created_at: Date;
        };
        p_priority: {
            transaction_type: string;
            consultation_name: string;
        };
    }[];
    user_patient: {
        id: number;
        users: {
            e_email: string;
            avatar_key: string;
        };
    };
    country: {
        id: number;
        country_name: string;
        is_national_license: boolean;
    };
}
